import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { painPoints } from '../data/landing';
export function PainPointsSection() {
  return <section aria-labelledby="reconoces" className="bg-cream" data-id="element-157" data-mp="2worl3y57a7g0">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" data-id="element-158" data-mp="2wmyegiul7n80">
        <SectionHeading title={<>
              ¿Te reconoces en alguna de <span className="italic text-coral" data-id="element-160" data-mp="35pg4l8dd500a">estas situaciones?</span>
            </>} intro="Si respondiste sí al menos una vez, este pack fue creado para ti." data-id="element-159" data-mp="2rowvdxx5vnwj" />

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-161" data-mp="30qcz5mth0rrs">
          {painPoints.map(point => <article key={point.title} className="flex gap-4 rounded-2xl bg-white p-6 shadow-soft sm:p-7" data-id="element-162" data-mp="3ferciroijyml">
              <span aria-hidden="true" className="text-xl leading-none" data-id="element-163" data-mp="3aiiw7aykxzdu">
                {point.icon}
              </span>
              <div data-id="element-164" data-mp="3kevqob1y8h9n">
                <h3 className="font-semibold leading-snug text-ink" data-id="element-165" data-mp="3kfezn29mfvbj">{point.title}</h3>
                <p className="mt-2 text-base leading-relaxed text-muted" data-id="element-166" data-mp="sv9ss2aij6g5">{point.body}</p>
              </div>
            </article>)}
        </div>

        <p className="mt-14 flex items-center justify-center gap-2 text-center text-sm font-semibold uppercase tracking-[0.14em] text-coral" data-id="element-167" data-mp="wwvb435tgcxq">
          Tu forma de estudiar inglés puede ser mucho más simple
          <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-168" data-mp="16vudj3zzncca" />
        </p>
      </div>
    </section>;
}